import React, {useEffect, useState} from "react";
import Button from "@prism/button";
import IconSvg from "@prism/icon";
import {connect} from "react-redux";
import {isNativeApp} from "../../../../utils/utils";
import {deleteDamageImage} from "../../../../actions/damageImageActions";
import Confirm from "../../../common/Confirm";
import {UPDATED, RETAKE_IMAGE_MESSAGE} from "../../../../utils/constants";

const capturePhoto = (props) => {
    const {damageId, auctionCode, category, title, workOrderNumber, vin} = props;

    if (isNativeApp()) {
        console.log(
            "capture photo with",
            auctionCode,
            workOrderNumber,
            damageId,
            category
        );
        window.NativeApp.capturePhoto(
            workOrderNumber,
            vin,
            damageId,
            category,
            title
        );
    } else {
        console.log(
            "camera not available in web view",
            auctionCode,
            workOrderNumber,
            damageId
        );
    }
};

const TakePhotoButton = (props) => {
    const {auctionCode, workOrderNumber} = props.workOrderInfo;
    const {vin} = props.designatedDescription
    const {damageId, damageImage, damageImages} = props;
    const [hasLocalImage, setHasLocalImage] = useState(false);

    const handleRetakePhotoClick = (captureRequest) => {
        if (isNativeApp()) {
            props.deleteDamageImage(damageId);
            capturePhoto(captureRequest);
            props.toggle && props.toggle();
        }
    };

    useEffect(() => setHasLocalImage(damageImage && damageImage.status === UPDATED), [damageImage, damageImages]);
    return props.hasPhoto ? (

        hasLocalImage ?
            <Confirm
                title="Retake Photo"
                description={RETAKE_IMAGE_MESSAGE}
                submitDescription="Retake"
                cancelDescription="Cancel"
            >
                {(confirm) => (
                    <Button
                        className="w-100 retake-photo"
                        color="secondary"
                        disabled={props.disabled}
                        id={"retake-photo-" + props.damageId}
                        onClick={confirm(() => {
                            handleRetakePhotoClick({
                                auctionCode: auctionCode,
                                workOrderNumber: workOrderNumber,
                                damageId: props.damageId,
                                vin: vin,
                                category: "DAMAGE",
                                title: props.title
                            })
                        })}
                    >
                        <IconSvg glyph="camera" height="35px" className="mr-2"/>
                        RETAKE PHOTO
                    </Button>
                )}
            </Confirm> :
            <Button
                className="w-100 retake-photo"
                color="secondary"
                disabled={props.disabled}
                id={"retake-photo-" + props.damageId}
                onClick={() =>
                    capturePhoto({
                        auctionCode: auctionCode,
                        workOrderNumber: workOrderNumber,
                        damageId: props.damageId,
                        vin: vin,
                        category: "DAMAGE",
                        title: props.title
                    })
                }
            >
                <IconSvg glyph="camera" height="35px" className="mr-2"/>
                RETAKE PHOTO
            </Button>
    ) : (
        <Button
            className="w-100 take-photo"
            color="secondary"
            disabled={props.disabled}
            onClick={() =>
                capturePhoto({
                    auctionCode: auctionCode,
                    workOrderNumber: workOrderNumber,
                    damageId: props.damageId,
                    vin: vin,
                    category: "DAMAGE",
                    title: props.title
                })
            }
        >
            <IconSvg glyph="camera" className="large-button-icon" height="35px" />
        </Button>
    );
};

function mapStateToProps({workOrderInfo, designatedDescription, damageImages}) {
    return {workOrderInfo, designatedDescription, damageImages};
}

const matchDispatchToProps = {
    deleteDamageImage
};

export default connect(mapStateToProps, matchDispatchToProps)(TakePhotoButton);
